import { render, staticRenderFns } from "./double-modal.vue?vue&type=template&id=4878a7bd&scoped=true&lang=pug&"
import script from "./double-modal.vue?vue&type=script&lang=js&"
export * from "./double-modal.vue?vue&type=script&lang=js&"
import style0 from "./double-modal.vue?vue&type=style&index=0&id=4878a7bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878a7bd",
  null
  
)

export default component.exports